import { type ClientModules, type MyClient } from "@pima/web-api/client";
import { runIntent } from "../run-intent";
import { getClient } from "./client";

// The caller's own client — module flags and measure categories the
// employee/dashboard screens gate on. Never call with a client id: the
// server always derives it from the caller's own session.
export async function fetchMyClient(): Promise<MyClient> {
  const client = await getClient();
  const { data } = await runIntent(client.client.getMyClient());
  return data;
}

export async function fetchMyClientModules(): Promise<ClientModules> {
  const client = await getClient();
  const { data } = await runIntent(client.client.getClientModules());
  return data;
}

export async function fetchMyClientSeatHolders() {
  const client = await getClient();
  const { data } = await runIntent(client.client.getMyClientSeatHolders());
  return [...data];
}
